/* eslint-disable */
/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-atobbtoa-blobconstructor-bloburls-borderradius-boxshadow-boxsizing-checked-cookies-cors-cssanimations-csspositionsticky-cssremunit-csstransforms-csstransitions-cssvwunit-datauri-displaytable-ellipsis-eventlistener-fetch-flexbox-flexwrap-hsla-input-json-lastchild-localstorage-mediaqueries-opacity-promises-requestanimationframe-rgba-svg-websockets-websocketsbinary-setclasses !*/
!(function (e, t, n) {
  function r(e, t) {
    return typeof e === t;
  }
  function i() {
    var e, t, n, i, o, a, s;
    for (var l in T)
      if (T.hasOwnProperty(l)) {
        if (
          ((e = []),
          (t = T[l]),
          t.name &&
            (e.push(t.name.toLowerCase()),
            t.options && t.options.aliases && t.options.aliases.length))
        )
          for (n = 0; n < t.options.aliases.length; n++)
            e.push(t.options.aliases[n].toLowerCase());
        for (i = r(t.fn, "function") ? t.fn() : t.fn, o = 0; o < e.length; o++)
          (a = e[o]),
            (s = a.split(".")),
            1 === s.length
              ? (Modernizr[s[0]] = i)
              : (!Modernizr[s[0]] ||
                  Modernizr[s[0]] instanceof Boolean ||
                  (Modernizr[s[0]] = new Boolean(Modernizr[s[0]])),
                (Modernizr[s[0]][s[1]] = i)),
            A.push((i ? "" : "no-") + s.join("-"));
      }
  }
  function o(e) {
    var t = k.className,
      n = Modernizr._config.classPrefix || "";
    if ((_ && (t = t.baseVal), Modernizr._config.enableJSClass)) {
      var r = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
      t = t.replace(r, "$1" + n + "js$2");
    }
    Modernizr._config.enableClasses &&
      ((t += " " + n + e.join(" " + n)),
      _ ? (k.className.baseVal = t) : (k.className = t));
  }
  function a() {
    return "function" != typeof t.createElement
      ? t.createElement(arguments[0])
      : _
      ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0])
      : t.createElement.apply(t, arguments);
  }
  function s(e, t) {
    return !!~("" + e).indexOf(t);
  }
  function l(t, n, r) {
    var i;
    if ("getComputedStyle" in e) {
      i = getComputedStyle.call(e, t, n);
      var o = e.console;
      if (null !== i) r && (i = i.getPropertyValue(r));
      else if (o) {
        var a = o.error ? "error" : "log";
        o[a].call(
          o,
          "getComputedStyle returning null, its possible modernizr test results are inaccurate"
        );
      }
    } else i = !n && t.currentStyle && t.currentStyle[r];
    return i;
  }
  function d(e, t) {
    return e - 1 === t || e === t || e + 1 === t;
  }
  function u(e) {
    return e
      .replace(/([a-z])-([a-z])/g, function (e, t, n) {
        return t + n.toUpperCase();
      })
      .replace(/^-/, "");
  }
  function c(e, t) {
    if ("object" == typeof e) for (var n in e) N(e, n) && c(n, e[n]);
    else {
      e = e.toLowerCase();
      var r = e.split("."),
        i = Modernizr[r[0]];
      if ((2 == r.length && (i = i[r[1]]), "undefined" != typeof i))
        return Modernizr;
      (t = "function" == typeof t ? t() : t),
        1 == r.length
          ? (Modernizr[r[0]] = t)
          : (!Modernizr[r[0]] ||
              Modernizr[r[0]] instanceof Boolean ||
              (Modernizr[r[0]] = new Boolean(Modernizr[r[0]])),
            (Modernizr[r[0]][r[1]] = t)),
        o([(t && 0 != t ? "" : "no-") + r.join("-")]),
        Modernizr._trigger(e, t);
    }
    return Modernizr;
  }
  function f() {
    var e = t.body;
    return e || ((e = a(_ ? "svg" : "body")), (e.fake = !0)), e;
  }
  function p(e, n, r, i) {
    var o,
      s,
      l,
      d,
      u = "modernizr",
      c = a("div"),
      p = f();
    if (parseInt(r, 10))
      for (; r--; )
        (l = a("div")), (l.id = i ? i[r] : u + (r + 1)), c.appendChild(l);
    return (
      (o = a("style")),
      (o.type = "text/css"),
      (o.id = "s" + u),
      (p.fake ? p : c).appendChild(o),
      p.appendChild(c),
      o.styleSheet
        ? (o.styleSheet.cssText = e)
        : o.appendChild(t.createTextNode(e)),
      (c.id = u),
      p.fake &&
        ((p.style.background = ""),
        (p.style.overflow = "hidden"),
        (d = k.style.overflow),
        (k.style.overflow = "hidden"),
        k.appendChild(p)),
      (s = n(c, e)),
      p.fake
        ? (p.parentNode.removeChild(p), (k.style.overflow = d), k.offsetHeight)
        : c.parentNode.removeChild(c),
      !!s
    );
  }
  function m(e, t) {
    return function () {
      return e.apply(t, arguments);
    };
  }
  function h(e, t, n) {
    var i;
    for (var o in e)
      if (e[o] in t)
        return n === !1
          ? e[o]
          : ((i = t[e[o]]), r(i, "function") ? m(i, n || t) : i);
    return !1;
  }
  function v(e) {
    return e
      .replace(/([A-Z])/g, function (e, t) {
        return "-" + t.toLowerCase();
      })
      .replace(/^ms-/, "-ms-");
  }
  function g(t, r) {
    var i = t.length;
    if ("CSS" in e && "supports" in e.CSS) {
      for (; i--; ) if (e.CSS.supports(v(t[i]), r)) return !0;
      return !1;
    }
    if ("CSSSupportsRule" in e) {
      for (var o = []; i--; ) o.push("(" + v(t[i]) + ":" + r + ")");
      return (
        (o = o.join(" or ")),
        p(
          "@supports (" + o + ") { #modernizr { position: absolute; } }",
          function (e) {
            return "absolute" == l(e, null, "position");
          }
        )
      );
    }
    return n;
  }
  function y(e, t, i, o) {
    function l() {
      c && (delete U.style, delete U.modElem);
    }
    if (((o = r(o, "undefined") ? !1 : o), !r(i, "undefined"))) {
      var d = g(e, i);
      if (!r(d, "undefined")) return d;
    }
    for (
      var c, f, p, m, h, v = ["modernizr", "tspan", "samp"];
      !U.style && v.length;

    )
      (c = !0), (U.modElem = a(v.shift())), (U.style = U.modElem.style);
    for (p = e.length, f = 0; p > f; f++)
      if (
        ((m = e[f]),
        (h = U.style[m]),
        s(m, "-") && (m = u(m)),
        U.style[m] !== n)
      ) {
        if (o || r(i, "undefined")) return l(), "pfx" == t ? m : !0;
        try {
          U.style[m] = i;
        } catch (y) {}
        if (U.style[m] != h) return l(), "pfx" == t ? m : !0;
      }
    return l(), !1;
  }
  function b(e, t, n, i, o) {
    var a = e.charAt(0).toUpperCase() + e.slice(1),
      s = (e + " " + q.join(a + " ") + a).split(" ");
    return r(t, "string") || r(t, "undefined")
      ? y(s, t, i, o)
      : ((s = (e + " " + I.join(a + " ") + a).split(" ")), h(s, t, n));
  }
  function w(e, t, r) {
    return b(e, n, n, t, r);
  }
  var A = [],
    T = [],
    x = {
      _version: "3.6.0",
      _config: {
        classPrefix: "",
        enableClasses: !0,
        enableJSClass: !0,
        usePrefixes: !0
      },
      _q: [],
      on: function (e, t) {
        var n = this;
        setTimeout(function () {
          t(n[e]);
        }, 0);
      },
      addTest: function (e, t, n) {
        T.push({ name: e, fn: t, options: n });
      },
      addAsyncTest: function (e) {
        T.push({ name: null, fn: e });
      }
    },
    Modernizr = function () {};
  (Modernizr.prototype = x),
    (Modernizr = new Modernizr()),
    Modernizr.addTest("cookies", function () {
      try {
        t.cookie = "cookietest=1";
        var e = -1 != t.cookie.indexOf("cookietest=");
        return (
          (t.cookie = "cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT"), e
        );
      } catch (n) {
        return !1;
      }
    }),
    Modernizr.addTest(
      "cors",
      "XMLHttpRequest" in e && "withCredentials" in new XMLHttpRequest()
    ),
    Modernizr.addTest("eventlistener", "addEventListener" in e),
    Modernizr.addTest(
      "blobconstructor",
      function () {
        try {
          return !!new Blob();
        } catch (e) {
          return !1;
        }
      },
      { aliases: ["blob-constructor"] }
    ),
    Modernizr.addTest(
      "json",
      "JSON" in e && "parse" in JSON && "stringify" in JSON
    ),
    Modernizr.addTest(
      "svg",
      !!t.createElementNS &&
        !!t.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect
    );
  var S = !1;
  try {
    S = "WebSocket" in e && 2 === e.WebSocket.CLOSING;
  } catch (C) {}
  Modernizr.addTest("websockets", S),
    Modernizr.addTest("promises", function () {
      return (
        "Promise" in e &&
        "resolve" in e.Promise &&
        "reject" in e.Promise &&
        "all" in e.Promise &&
        "race" in e.Promise &&
        (function () {
          var t;
          return (
            new e.Promise(function (e) {
              t = e;
            }),
            "function" == typeof t
          );
        })()
      );
    }),
    Modernizr.addTest("fetch", "fetch" in e),
    Modernizr.addTest("localstorage", function () {
      var e = "modernizr";
      try {
        return localStorage.setItem(e, e), localStorage.removeItem(e), !0;
      } catch (t) {
        return !1;
      }
    }),
    Modernizr.addTest("websocketsbinary", function () {
      var t,
        n = "https:" == location.protocol ? "wss" : "ws";
      if ("WebSocket" in e) {
        if ((t = "binaryType" in WebSocket.prototype)) return t;
        try {
          return !!new WebSocket(n + "://.").binaryType;
        } catch (r) {}
      }
      return !1;
    }),
    Modernizr.addTest("atobbtoa", "atob" in e && "btoa" in e, {
      aliases: ["atob-btoa"]
    });
  var k = t.documentElement,
    _ = "svg" === k.nodeName.toLowerCase();
  Modernizr.addTest("cssremunit", function () {
    var e = a("a").style;
    try {
      e.fontSize = "3rem";
    } catch (t) {}
    return /rem/.test(e.fontSize);
  }),
    Modernizr.addTest("rgba", function () {
      var e = a("a").style;
      return (
        (e.cssText = "background-color:rgba(150,255,150,.5)"),
        ("" + e.backgroundColor).indexOf("rgba") > -1
      );
    });
  var z = a("input"),
    O = "autocomplete autofocus list placeholder max min multiple pattern required step".split(
      " "
    ),
    P = {};
  (Modernizr.input = (function (t) {
    for (var n = 0, r = t.length; r > n; n++) P[t[n]] = !!(t[n] in z);
    return P.list && (P.list = !(!a("datalist") || !e.HTMLDataListElement)), P;
  })(O)),
    Modernizr.addTest("hsla", function () {
      var e = a("a").style;
      return (
        (e.cssText = "background-color:hsla(120,40%,100%,.5)"),
        s(e.backgroundColor, "rgba") || s(e.backgroundColor, "hsla")
      );
    });
  var L = x._config.usePrefixes
    ? " -webkit- -moz- -o- -ms- ".split(" ")
    : ["", ""];
  (x._prefixes = L),
    Modernizr.addTest("opacity", function () {
      var e = a("a").style;
      return (e.cssText = L.join("opacity:.55;")), /^0.55$/.test(e.opacity);
    }),
    Modernizr.addTest("csspositionsticky", function () {
      var e = "position:",
        t = "sticky",
        n = a("a"),
        r = n.style;
      return (
        (r.cssText = e + L.join(t + ";" + e).slice(0, -e.length)),
        -1 !== r.position.indexOf(t)
      );
    });
  var N;
  !(function () {
    var e = {}.hasOwnProperty;
    N =
      r(e, "undefined") || r(e.call, "undefined")
        ? function (e, t) {
            return t in e && r(e.constructor.prototype[t], "undefined");
          }
        : function (t, n) {
            return e.call(t, n);
          };
  })(),
    (x._l = {}),
    (x.on = function (e, t) {
      this._l[e] || (this._l[e] = []),
        this._l[e].push(t),
        Modernizr.hasOwnProperty(e) &&
          setTimeout(function () {
            Modernizr._trigger(e, Modernizr[e]);
          }, 0);
    }),
    (x._trigger = function (e, t) {
      if (this._l[e]) {
        var n = this._l[e];
        setTimeout(function () {
          var e, r;
          for (e = 0; e < n.length; e++) (r = n[e])(t);
        }, 0),
          delete this._l[e];
      }
    }),
    Modernizr._q.push(function () {
      x.addTest = c;
    }),
    Modernizr.addAsyncTest(function () {
      function e() {
        var e = new Image();
        (e.onerror = function () {
          c("datauri", !0),
            (Modernizr.datauri = new Boolean(!0)),
            (Modernizr.datauri.over32kb = !1);
        }),
          (e.onload = function () {
            c("datauri", !0),
              (Modernizr.datauri = new Boolean(!0)),
              (Modernizr.datauri.over32kb = 1 == e.width && 1 == e.height);
          });
        for (
          var t = "R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
          t.length < 33e3;

        )
          t = "\r\n" + t;
        e.src = "data:image/gif;base64," + t;
      }
      -1 !== navigator.userAgent.indexOf("MSIE 7.") &&
        setTimeout(function () {
          c("datauri", !1);
        }, 10);
      var t = new Image();
      (t.onerror = function () {
        c("datauri", !1);
      }),
        (t.onload = function () {
          1 == t.width && 1 == t.height ? e() : c("datauri", !1);
        }),
        (t.src =
          "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==");
    });
  var E = (x.testStyles = p);
  Modernizr.addTest("checked", function () {
    return E(
      "#modernizr {position:absolute} #modernizr input {margin-left:10px} #modernizr :checked {margin-left:20px;display:block}",
      function (e) {
        var t = a("input");
        return (
          t.setAttribute("type", "checkbox"),
          t.setAttribute("checked", "checked"),
          e.appendChild(t),
          20 === t.offsetLeft
        );
      }
    );
  }),
    E(
      "#modernizr{display: table; direction: ltr}#modernizr div{display: table-cell; padding: 10px}",
      function (e) {
        var t,
          n = e.childNodes;
        (t = n[0].offsetLeft < n[1].offsetLeft),
          Modernizr.addTest("displaytable", t, { aliases: ["display-table"] });
      },
      2
    ),
    E(
      "#modernizr div {width:100px} #modernizr :last-child{width:200px;display:block}",
      function (e) {
        Modernizr.addTest(
          "lastchild",
          e.lastChild.offsetWidth > e.firstChild.offsetWidth
        );
      },
      2
    ),
    E("#modernizr { width: 50vw; }", function (t) {
      var n = parseInt(e.innerWidth / 2, 10),
        r = parseInt(l(t, null, "width"), 10);
      Modernizr.addTest("cssvwunit", d(r, n));
    });
  var j = (function () {
    var t = e.matchMedia || e.msMatchMedia;
    return t
      ? function (e) {
          var n = t(e);
          return (n && n.matches) || !1;
        }
      : function (t) {
          var n = !1;
          return (
            p(
              "@media " + t + " { #modernizr { position: absolute; } }",
              function (t) {
                n =
                  "absolute" ==
                  (e.getComputedStyle
                    ? e.getComputedStyle(t, null)
                    : t.currentStyle
                  ).position;
              }
            ),
            n
          );
        };
  })();
  (x.mq = j), Modernizr.addTest("mediaqueries", j("only all"));
  var R = "Moz O ms Webkit",
    q = x._config.usePrefixes ? R.split(" ") : [];
  x._cssomPrefixes = q;
  var B = function (t) {
    var r,
      i = L.length,
      o = e.CSSRule;
    if ("undefined" == typeof o) return n;
    if (!t) return !1;
    if (
      ((t = t.replace(/^@/, "")),
      (r = t.replace(/-/g, "_").toUpperCase() + "_RULE"),
      r in o)
    )
      return "@" + t;
    for (var a = 0; i > a; a++) {
      var s = L[a],
        l = s.toUpperCase() + "_" + r;
      if (l in o) return "@-" + s.toLowerCase() + "-" + t;
    }
    return !1;
  };
  x.atRule = B;
  var I = x._config.usePrefixes ? R.toLowerCase().split(" ") : [];
  x._domPrefixes = I;
  var M = { elem: a("modernizr") };
  Modernizr._q.push(function () {
    delete M.elem;
  });
  var U = { style: M.elem.style };
  Modernizr._q.unshift(function () {
    delete U.style;
  }),
    (x.testAllProps = b),
    (x.testAllProps = w),
    Modernizr.addTest("cssanimations", w("animationName", "a", !0)),
    Modernizr.addTest("borderradius", w("borderRadius", "0px", !0)),
    Modernizr.addTest("boxshadow", w("boxShadow", "1px 1px", !0)),
    Modernizr.addTest(
      "boxsizing",
      w("boxSizing", "border-box", !0) &&
        (t.documentMode === n || t.documentMode > 7)
    ),
    Modernizr.addTest("ellipsis", w("textOverflow", "ellipsis")),
    Modernizr.addTest("flexbox", w("flexBasis", "1px", !0)),
    Modernizr.addTest("flexwrap", w("flexWrap", "wrap", !0)),
    Modernizr.addTest("csstransforms", function () {
      return (
        -1 === navigator.userAgent.indexOf("Android 2.") &&
        w("transform", "scale(1)", !0)
      );
    }),
    Modernizr.addTest("csstransitions", w("transition", "all", !0));
  var W = (x.prefixed = function (e, t, n) {
    return 0 === e.indexOf("@")
      ? B(e)
      : (-1 != e.indexOf("-") && (e = u(e)), t ? b(e, t, n) : b(e, "pfx"));
  });
  Modernizr.addTest("requestanimationframe", !!W("requestAnimationFrame", e), {
    aliases: ["raf"]
  });
  var J = W("URL", e, !1);
  (J = J && e[J]),
    Modernizr.addTest(
      "bloburls",
      J && "revokeObjectURL" in J && "createObjectURL" in J
    ),
    i(),
    o(A),
    delete x.addTest,
    delete x.addAsyncTest;
  for (var G = 0; G < Modernizr._q.length; G++) Modernizr._q[G]();
  e.Modernizr = Modernizr;
})(window, document);
